import initializeBigNumber from './bigNumber';
import initializeYup from './yup';

const initializeLibraries = () => {
  initializeBigNumber();
  initializeYup();
};

export default initializeLibraries;
